import customDate from './date-format'
export default {
  customDate
}